// Fenster an den linken oder rechten Rand andocken — wie in Windows (User
// 26.10.2026: „wenn ich ein Fenster in einen Rand links oder rechts ziehe, dann
// nimmt das den halben Bildschirm und das andere Fenster kann ich dann in den
// anderen Rand schieben"). Bewusst React-frei, damit die Rechnung ohne DOM
// geprüft werden kann.

export type AndockSeite = "links" | "rechts";

type Groesse = { width: number; height: number };
type Punkt = { x: number; y: number };

/**
 * So nah (px) muss der Zeiger an den Rand der Fensterfläche, damit das Fenster
 * beim Loslassen andockt. Links liegt das Menü daneben: Wer den Zeiger darüber
 * hinaus zieht, meint denselben Rand.
 */
export const ANDOCK_RAND = 16;

/** Welcher Rand, wenn der Zeiger bei `zeigerX` losgelassen wird — oder keiner. */
export function andockSeiteFuer(
  zeigerX: number,
  flaeche: { left: number; right: number },
): AndockSeite | null {
  if (flaeche.right - flaeche.left <= 2 * ANDOCK_RAND) return null;
  if (zeigerX <= flaeche.left + ANDOCK_RAND) return "links";
  if (zeigerX >= flaeche.right - ANDOCK_RAND) return "rechts";
  return null;
}

/** Lage und Größe eines angedockten Fensters: die halbe Fläche, volle Höhe. */
export function andockGeometrie(
  seite: AndockSeite,
  flaeche: Groesse,
): { position: Punkt; size: Groesse } {
  const halb = Math.floor(flaeche.width / 2);
  return seite === "links"
    ? { position: { x: 0, y: 0 }, size: { width: halb, height: flaeche.height } }
    : { position: { x: halb, y: 0 }, size: { width: flaeche.width - halb, height: flaeche.height } };
}

/**
 * Wohin ein Fenster kommt, das vom Rand weggezogen wird und dabei seine alte
 * Größe zurückbekommt: Der Zeiger soll an derselben Stelle der Titelleiste
 * bleiben (anteilig), sonst hielte man das kleinere Fenster plötzlich neben
 * seiner Titelleiste fest.
 */
export function abdockPosition(args: {
  /** Zeiger beim Loslassen, relativ zur Fensterfläche. */
  zeigerX: number;
  /** Lage des (noch breiten) Fensters beim Loslassen. */
  position: Punkt;
  breiteAngedockt: number;
  breiteVorher: number;
}): Punkt {
  const { zeigerX, position, breiteAngedockt, breiteVorher } = args;
  const anteil =
    breiteAngedockt > 0 ? Math.min(1, Math.max(0, (zeigerX - position.x) / breiteAngedockt)) : 0.5;
  return { x: Math.round(zeigerX - anteil * breiteVorher), y: position.y };
}
